var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculateRates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 57,
    viewBox: "0 0 62 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.3857 41.686L35.8914 54.4501L11.5 41.6866V14.9265L35.8914 2.56035L60.3857 14.9271V41.686Z",
    stroke: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 41.6864V15.4447L35.4428 27.9473V54.1891L11.5 41.6864Z",
    stroke: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8909 55.0142L60.8857 41.9893V14.6194L35.8909 2L11 14.6194V41.9893L35.8909 55.0142Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.6195L35.9428 27.6444L61 14.6195",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9424 27.9869V55.0138",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.762 37.9871L43.2178 44.619",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6104 24.8689V35.2638",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0227 29.4528L53.6105 25.2117L56.1983 26.9684",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2966 29.0271V39.422",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.709 33.611L45.2968 29.3699L47.8846 31.1266",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11 53.8571L21 48.1918V36.902L11 31L1 36.902V48.1918L11 53.8571Z",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.95288 36.7141L11.0062 42.4284L20.0481 36.7141",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4763 42.4283V52.9045",
    stroke: "#BDBDBD",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculateRates);
export default __webpack_public_path__ + "static/media/calculate-rates.6bdfa129.svg";
export { ForwardRef as ReactComponent };